import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
var _ = function _(t) {
    return t;
  },
  _t,
  _t2;
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import css from './style.pcss';
import * as dayjs from "dayjs";
import { detect } from "../../common/detect";
var ESCVoting = /*#__PURE__*/function (_LitElement) {
  _inherits(ESCVoting, _LitElement);
  function ESCVoting() {
    var _this;
    _classCallCheck(this, ESCVoting);
    _this = _callSuper(this, ESCVoting);
    _this.site = 'rtl';
    _this.lang = 'en';
    _this.show = true;
    if (window.rtlsites) {
      _this.site = window.rtlsites.config.site;
      if (_this.site === 'eurovision') _this.lang = 'en';else {
        _this.lang = window.rtlsites.config.language;
      }
    }
    if (process.env.NODE_ENV == 'development') {
      _this.location = "http://localhost:8080";
    }

    //this._checkTime();
    //this.check = setInterval(this._checkTime.bind(this), 30000); // 30000
    return _this;
  }
  _createClass(ESCVoting, [{
    key: "_checkTime",
    value: function _checkTime() {
      var cTime = dayjs().format('HHmm');
      var cDay = dayjs().format('DDMMYY');
      if (cDay === '110524') {
        // 270124
        //this.show  = cTime >= 2000 && cTime <= 2240; // 1950 - 2230
        this.show = cTime >= 1955 && cTime <= 2240; // 1950 - 2230
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.show) return html(_t || (_t = _``));
      var link = "https://esc.vote";
      if (window.rtlsites.config.isApp) link = window.rtlsites.config.currentApp + "://safari/https://esc.vote";
      return html(_t2 || (_t2 = _`
            <style>${0}</style>
            <div class="banner-container">
                <a href="${0}" target="_blank"><img src="/assets/images/eurovision/voting_banner_${0}.png" alt="Eurovision Song Contest Voting" class="banner" /></a>
            </div>
        `), css, link, this.lang);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        lang: {
          type: String
        },
        show: {
          type: Boolean
        }
      };
    }
  }]);
  return ESCVoting;
}(LitElement);
export { ESCVoting as default };
window.customElements.define('esc-voting', ESCVoting);